module.exports = __webpack_public_path__ + "static/img/service-staffs.4e1e5061.jpg";